import PdfLinkIcon from '@/../img/pdf-link-icon';
import React from 'react';
import { IconWrapper } from './cell-styles';

// TODO: may have to use presigned url
export function PdfLinkCell({ value }) {
  if (!value) return <div />; // must return a component

  return (
    <IconWrapper height={20} width={20}>
      <PdfLinkIcon onClick={() => window.open(value, '_blank')} />
    </IconWrapper>
  );
}
